import { LockOpenOutlined } from '@mui/icons-material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { BreadcrumbMeta } from 'v2/components/Breadcrumb/Breadcrumb';
import EmptyStateOverview from 'v2/components/EmptyStateOverview/EmptyStateOverview';
import OverviewContent from 'v2/components/OverviewContent/OverviewContent';
import PageTabs from 'v2/components/PageTabs/PageTabs';
import SearchAndFilters from 'v2/components/SearchAndFilters/SearchAndFilters';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useCloudControllerList from 'v2/hooks/useCloudControllers/useCloudControllerList';
import { getCloudControllerPath } from 'v2/paths';
import { createDeviceTabs } from '../createDeviceTabs';
import TableWithData from './components/TableWithData';
import { useCloudControllersSearch } from './useCloudControllersSearch';

const CloudControllers: React.FC = () => {
  const { translation } = useTranslation();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbarContext();
  const { cloudControllers, cloudControllersLoading } = useCloudControllerList({
    translation,
    handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' })
  });

  const { filterStr, setFilterStr, filteredCloudControllers, countCaption } = useCloudControllersSearch({
    cloudControllers
  });

  const handleRowClick = (id: string) => navigate(getCloudControllerPath(id));

  const tabs = createDeviceTabs(translation);
  const breadcrumb = {
    title: translation.cloud_controllers,
    crumbs: [
      {
        text: translation.devices,
        path: '/devices'
      }
    ]
  };

  return (
    <>
      <BreadcrumbMeta breadcrumb={breadcrumb} />
      <PageTabs tabs={tabs} />
      <SearchAndFilters
        filterStr={filterStr}
        onFilterStrChange={setFilterStr}
        sections={[]}
        chips={[]}
        countCaption={countCaption}
      />
      <OverviewContent
        loading={cloudControllersLoading}
        hasData={cloudControllers.length > 0}
        hasResults={filteredCloudControllers.length > 0}
        table={
          <TableWithData
            cloudControllers={filteredCloudControllers}
            onRowClick={handleRowClick}
            loading={cloudControllersLoading}
          />
        }
        noResults={
          <EmptyStateOverview
            icon={LockOpenOutlined}
            title={translation.no_results}
            content={translation.no_results_search_and_filters_description}
          />
        }
        noData={
          <EmptyStateOverview
            icon={LockOpenOutlined}
            title={translation.no_results}
            content={translation.no_cloud_controllers_in_system}
          />
        }
      />
    </>
  );
};

export default CloudControllers;
